import { render, staticRenderFns } from "./editPapers.vue?vue&type=template&id=4794a333&scoped=true&"
import script from "./editPapers.vue?vue&type=script&lang=js&"
export * from "./editPapers.vue?vue&type=script&lang=js&"
import style0 from "./editPapers.vue?vue&type=style&index=0&id=4794a333&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794a333",
  null
  
)

export default component.exports